<app-auth-layout [heading]="sideHeading" [bullets]="sideBullets" pill="Free trial">
  <h1>Create your account</h1>
  <p class="auth__lead">Set up your company on {{ appName }} in three quick steps.</p>

  <div class="steps" role="group" [attr.aria-label]="'Step ' + currentStep + ' of ' + totalSteps">
    <div class="steps__meta">
      <strong>{{ stepLabel }}</strong>
      <span>Step {{ currentStep }} of {{ totalSteps }}</span>
    </div>
    <div class="steps__bar" aria-hidden="true">
      <span *ngFor="let label of stepLabels; let i = index" [class.is-done]="i < currentStep"></span>
    </div>
  </div>

  <form class="auth__form" [formGroup]="signupForm" (ngSubmit)="onSubmit()" novalidate>
    <app-signup-step-one
      *ngIf="currentStep === 1"
      [formGroup]="signupForm"
      (nextStep)="nextStep()"
    ></app-signup-step-one>

    <app-signup-step-two
      *ngIf="currentStep === 2"
      [formGroup]="signupForm"
      (nextStep)="nextStep()"
      (previousStep)="previousStep()"
    ></app-signup-step-two>

    <app-signup-step-three
      *ngIf="currentStep === 3"
      [formGroup]="signupForm"
      [isLoading]="isLoading"
      [captchaQuestion]="captcha.question"
      (previousStep)="previousStep()"
    ></app-signup-step-three>

    <div class="auth-error" role="alert" *ngIf="errorMessage">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="auth-success" role="status" *ngIf="successMessage">
      <i class="fa fa-check-circle" aria-hidden="true"></i>
      <span>{{ successMessage }}</span>
    </div>
  </form>

  <p class="auth__alt">
    Already a customer? Sign in at
    <a class="auth__link" [href]="loginUrl" rel="noopener">app.shiftclockai.com</a>
    with your company code.
  </p>
</app-auth-layout>
